import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageLoader } from 'ia-react-core';

export interface CustomPageLoaderProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loader: () => Promise<any>;
}

const CustomPageLoader: FC<CustomPageLoaderProps> = ({ loader, ...props }) => {
  const { t } = useTranslation('App');
  return (
    <PageLoader
      errorTitle={t('ErrorTitle')}
      errorMessage={t('ErrorMessage')}
      errorRetryButton={t('ErrorRetryButton')}
      loader={loader}
      {...props}
    />
  );
};

export default CustomPageLoader;
